import {GetExamsPreparation} from 'domain/usecases/private/booking-flow/exams/get-exams-preparation';
import {RemoteGetExamPreparation} from 'data/usecases/private/booking-flow/exams/remote-get-exams-preparation';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants/featuresFlagEnum';

export const makeGetExamsPreparation = (): GetExamsPreparation => {
	const isExamsPreparationsV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_PREPARATIONS_V3,
	);

	const endpoint = isExamsPreparationsV3Enabled
		? BookingFlowEndPoints.examPreparationV3
		: BookingFlowEndPoints.examPreparation;

	return new RemoteGetExamPreparation(
		makeBFFApiUrl(endpoint),
		makeAuthorizeHttpClientDecorator(),
	);
};
